import { RiskClassLevel } from "../models";

export enum ActionTypes {
  MAP_DOWNLOAD_HEADER_SET = "MAP_DOWNLOAD_HEADER_SET",
  MAP_DOWNLOAD_DESC_SET = "MAP_DOWNLOAD_DESC_SET",
  MAP_DOWNLOAD_DEF_SET = "MAP_DOWNLOAD_DEF_SET",
  MAP_DOWNLOAD_LEVEL_SET = "MAP_DOWNLOAD_LEVEL_SET",
  MAP_DOWNLOAD_DATA_URL_SET = "MAP_DOWNLOAD_DATA_URL_SET"
}

export type MapDownloadAction =
  | {
      readonly type: ActionTypes.MAP_DOWNLOAD_HEADER_SET;
      readonly header: string;
    }
  | { readonly type: ActionTypes.MAP_DOWNLOAD_DESC_SET; description: string }
  | { readonly type: ActionTypes.MAP_DOWNLOAD_DEF_SET; definition: string }
  | { readonly type: ActionTypes.MAP_DOWNLOAD_LEVEL_SET; riskLevel: RiskClassLevel | null }
  | { readonly type: ActionTypes.MAP_DOWNLOAD_DATA_URL_SET; dataUrl: string };

export function setMapDownloadHeader(header: string): MapDownloadAction {
  return {
    type: ActionTypes.MAP_DOWNLOAD_HEADER_SET,
    header
  };
}

export function setMapDownloadDescription(description: string): MapDownloadAction {
  return {
    type: ActionTypes.MAP_DOWNLOAD_DESC_SET,
    description
  };
}

export function setMapDownloadDefinition(definition: string): MapDownloadAction {
  return {
    type: ActionTypes.MAP_DOWNLOAD_DEF_SET,
    definition
  };
}

export function setMapDownloadRiskLevel(riskLevel: RiskClassLevel): MapDownloadAction {
  return {
    type: ActionTypes.MAP_DOWNLOAD_LEVEL_SET,
    riskLevel
  };
}

export function setMapDownloadDataUrl(dataUrl: string): MapDownloadAction {
  return {
    type: ActionTypes.MAP_DOWNLOAD_DATA_URL_SET,
    dataUrl
  };
}
